import React, { useState } from 'react';
import './Accordion.css';
import { useTranslation } from 'react-i18next';
import Laluvit_gore from '../assets/lal_formula_gore.png';
import Laluvit_dole from '../assets/lal_formula_dole.png';
import laluvit from '../assets/laluvit.png';
import tubulin from '../assets/tubulin.png';
import neurofilament from '../assets/neuroFilament.png';
import osecajStranogTela from '../assets/osecajStranogTela.png';
import osecajBockanja from '../assets/osecajBockanja.png';
import nelagodnostPriTreptanju from '../assets/nelagodnostPriTreptanju.png';
import ociDrzeZatvorene from '../assets/ociDrzeZatvorene.png';
import alfaLogo from '../assets/AlfaIntes.svg';

const Bullet = ({ children, highlight }) => (
  <p className={`compound-list__item${highlight ? ' compound-list__item--highlight' : ''}`}>
    <span className="compound-list__dot" aria-hidden="true" />
    <span>{children}</span>
  </p>
);

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`accordion-item${isOpen ? ' is-open' : ''}`}>
      <button
        className="accordion-header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        type="button"
      >
        <span className="accordion-header__title">{title}</span>
        <span className="accordion-header__icon" aria-hidden="true">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      {isOpen && <div className="accordion-content">{content}</div>}
    </div>
  );
};

const LalAccordion = () => {
  const [t] = useTranslation('global');

  return (
    <div className="accordion">
      <AccordionItem
        title={t('laluvit.accordianTitle_1')}
        content={
          <div className="compound-stack">
            <div className="compound-block">
              <p className="compound-title">{t('laluvit.accordianTitle_1_naslov_1')}</p>
              <div className="compound-list">
                <Bullet>{t('laluvit.accordianTitle_1_naslov_1_b_2')}</Bullet>
                <Bullet>{t('laluvit.accordianTitle_1_naslov_1_b_3')}</Bullet>
                <Bullet highlight>{t('laluvit.accordianTitle_1_naslov_1_b_4')}</Bullet>
              </div>
            </div>
            <div className="compound-row">
              <div className="compound-block">
                <p className="compound-title">{t('laluvit.accordianTitle_1_naslov_2')}</p>
                <div className="compound-list">
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_2_b_1')}</Bullet>
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_2_b_2')}</Bullet>
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_2_b_3')}</Bullet>
                </div>
              </div>
              <div className="compound-formula">
                <img src={Laluvit_gore} alt={t('laluvit.accordianopisSlike_1')} />
              </div>
            </div>
            <div className="compound-row">
              <div className="compound-block">
                <p className="compound-title compound-title--accent">
                  {t('laluvit.accordianTitle_1_naslov_3')}
                </p>
                <div className="compound-list">
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_3_b_1')}</Bullet>
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_3_b_2')}</Bullet>
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_3_b_3')}</Bullet>
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_3_b_4')}</Bullet>
                  <Bullet>{t('laluvit.accordianTitle_1_naslov_3_b_5')}</Bullet>
                </div>
              </div>
              <div className="compound-formula">
                <img src={Laluvit_dole} alt={t('laluvit.accordianopisSlike_1')} />
              </div>
            </div>
          </div>
        }
      />
      <AccordionItem
        title={t('laluvit.accordianTitle_2')}
        content={
          <>
            <p className="lead lead--spaced">{t('laluvit.laluvitBenefiti_1')}</p>
            <div className="accordionText chart-pair">
              <div>
                <img src={tubulin} alt={t('laluvit.accordianopisSlike_1')} />
              </div>
              <div>
                <img src={neurofilament} alt={t('laluvit.accordianopisSlike_1')} />
              </div>
            </div>
            <p className="lead lead--spaced-lg lead--single-line">
              {t('laluvit.laluvitBenefiti_2')}
            </p>
            <div className="benefits-grid">
              <div className="benefits">
                <img src={osecajStranogTela} alt={t('laluvit.accordianopisSlike_1')} />
                <p>{t('laluvit.laluvitBenefiti_3')}</p>
              </div>
              <div className="benefits">
                <img src={osecajBockanja} alt={t('laluvit.accordianopisSlike_1')} />
                <p>{t('laluvit.laluvitBenefiti_4')}</p>
              </div>
              <div className="benefits">
                <img src={nelagodnostPriTreptanju} alt={t('laluvit.accordianopisSlike_1')} />
                <p>{t('laluvit.laluvitBenefiti_5')}</p>
              </div>
              <div className="benefits">
                <img src={ociDrzeZatvorene} alt={t('laluvit.accordianopisSlike_1')} />
                <p>{t('laluvit.laluvitBenefiti_6')}</p>
              </div>
            </div>
            <div className="accordion-refs">
              <p>{t('laluvit.reference_1')}</p>
              <p>{t('laluvit.reference_2')}</p>
            </div>
          </>
        }
      />
      <AccordionItem
        title={t('laluvit.accordianTitle_3')}
        content={
          <div className="accordionList">
            <p className="lead">{t('laluvit.accordianText_3')}</p>
            <div className="compound-list">
              <Bullet>{t('laluvit.bullet_1')}</Bullet>
              <p className="nested-note">{t('laluvit.bullet_1_1')}</p>
              <Bullet>{t('laluvit.bullet_2')}</Bullet>
              <p className="nested-note">{t('laluvit.bullet_2_2')}</p>
              <Bullet>{t('laluvit.bullet_3')}</Bullet>
              <p className="nested-note">{t('laluvit.bullet_3_3')}</p>
            </div>
          </div>
        }
      />
      <AccordionItem
        title={t('laluvit.accordianTitle_4')}
        content={
          <div className="accordionText">
            <div className="accordianlogo">
              <ul>
                <li>
                  <span>{t('idroflog.doziranje_label')}</span>
                  {t('laluvit.doziranje')}
                </li>
                <li>
                  <span>{t('idroflog.pakovanje_label')}</span>
                  {t('laluvit.pakovanje')}
                </li>
                <li>
                  <span>{t('laluvit.sadrzi')}</span>
                </li>
                <li>
                  <span>{t('laluvit.kompatibilnost')}</span>
                </li>
                <li>
                  <span>{t('idroflog.proizvodjac_label')}</span>
                  {t('laluvit.proizvodjac')}
                </li>
              </ul>
              <img src={alfaLogo} alt={t('idroflog.accordianopisSlike_1')} />
            </div>
            <div className="proizvod">
              <img src={laluvit} alt={t('laluvit.accordianopisSlike_1')} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default LalAccordion;
